import { TabPanel } from '@mui/lab';
import {
  Box,
  Typography,
  styled,
  Button,
  IconButton,
  Grid,
  Tab,
} from '@mui/material';

export const BackButton = styled(IconButton)(({ theme }) => ({
  margin: '-20px 0 -10px -30px',
  '& span': {
    fontSize: 40,
    color: theme.palette.secondary.main,
  },
}));

export const ConfigurationWrapper = styled(Grid)(() => ({
  height: '100%',
  margin: '20px -20px',
}));

export const StyledTabPanel = styled(TabPanel)(() => ({
  backgroundColor: '#FFFFFE',
  boxShadow: '0px 1px 2px #61335429',
  minHeight: '400px',
  padding: '32px',
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  padding: '26px 40px',
  borderRadius: '20px 20px 0 0',
  color: theme.palette.primary.dark,
  textTransform: 'none',
  fontSize: '18px',
  fontWeight: '600',
  '&.Mui-selected': {
    backgroundColor: '#FFFFFE',
    boxShadow: '0px 1px 2px #61335429',
  },
  [theme.breakpoints.down('xl')]: {
    padding: '20px',
  },
}));

export const NoticeTitle = styled(Typography)(() => ({
  fontSize: '21px',
  color: '#707070',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  height: '100%',
}));

export const InputTitle = styled(Typography)(() => ({
  color: '#707070',
  paddingBottom: '4px',
  paddingRight: '12px',
  fontSize: '16px',
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  color: '#707070',
}));

export const MoreTypography = styled(Typography)(({ theme }) => ({
  mt: 1,
  cursor: 'pointer',
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const NoticeContainer = styled(Box)(() => ({
  padding: '10px 10px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '184px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '10px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  height: '56px',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const TableSection = styled(Box)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const AddButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.common.white,
  fontWeight: '600',
  height: '56px',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
  '&:disabled': {
    color: theme.palette.common.white,
  },
}));
